import { useRouter } from "@core/Api/useRouter";
import { useIsDiffView } from "@ext/git/core/Diff/logic/hooks/useIsDiffView";

export const useDiffMode = () => {
	const router = useRouter();
	const isDiff = useIsDiffView();
	const isMarkdown = router.query?.mode === "markdown";

	return { isDiff, isMarkdown, isWysiwyg: !isMarkdown };
};
